import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, View } from '@olxbr/design-system'

import Icons from '@olxbr/olx-icons'
import Link from '../../atoms/Link'
import { ajuda } from '../../../config/staticUrl'

const Box = styled(View)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 73px;
  background-color: #e5e5e5;
  padding: 16px;
`

const Title = styled(Text)`
  font-size: 14px;
  color: #4a4a4a;
  line-height: 20px;
  font-weight: 700;
`

const Content = styled(Text)`
  font-size: 14px;
  color: #4a4a4a;
  line-height: 20px;
  font-weight: 400;
`

const DetailColumn = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
`

const LinkRow = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 1;
`
const IconWrapper = styled(View)`
  padding-top: 8px;
`

const TemporaryWarningBox = props => {
  const { title, text } = props

  return (
    <Box>
      <IconWrapper>
        <Icons.System.Clock color="#000000" size="18" />
      </IconWrapper>
      <DetailColumn>
        <Title>{title}</Title>
        <Content>{text}</Content>
      </DetailColumn>
    </Box>
  )
}

TemporaryWarningBox.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default TemporaryWarningBox
